import { CustomDropdownValues } from 'types/qa.types';
import omit from 'lodash/omit';

/*
  These will reference the type of survey we are on, globally.
  Of course, they will have id's, but route wise, and constants wise - use this.

  These MUST line up with the route intent.
     For instance, you should NOT have /survey/energy-efficiency !!
     This does not match "energy" (of course you can change this const here). But the goal
     must be that they align. These values will be the SAME as the seoNames returned with associated
     id's, for the survey.
*/

export const SURVEY_TYPES = {
  'energy-efficiency': 'energy-efficiency',
  security: 'security',
  home: 'home',
  connectivity: 'connectivity',
  user: 'user',
} as const;

export const SURVEY_TYPES_SANS_USER = omit(SURVEY_TYPES, 'user');

export const DIRECTION_NEXT = 'next';
export const DIRECTION_PREVIOUS = 'previous';
export const DIRECTION_COMPLETED = 'completed';

/* This animates the direction of our flow */
export const ANIMATION_DIRECTION = {
  [DIRECTION_NEXT]: { from: '100%', enter: '0%', leave: '-100%' },
  [DIRECTION_PREVIOUS]: { from: '-100%', enter: '0%', leave: '100%' },
  [DIRECTION_COMPLETED]: { from: '0%', enter: '0%', leave: '0%' },
};

/* We need to only allow acceptable parms in the SSR and question flow, so we can */
export const ALLOWABLE_SSR_PARAMS = ['name', 'email'];

/* Answer Selector (Element) Types */
export const ANSWER_SELECTOR_TYPES = {
  radio: 'radio',
  checkbox: 'checkbox',
  dropdown: 'dropdown',
  input: 'input',
  input_text: 'input_text',
  input_address: 'input_address',
  input_numeric: 'input_numeric',
  input_currency: 'input_currency',
  device: 'device',
  superstitial: 'superstitial',
};

/* Flow animation directions: not used much but breaking it out anyways */
export const FLOW_ANIMATION_DIRECTION = {
  next: 'next',
  previous: 'previous',
} as const;

/* Custom Dropdown Attributes: move to utils */
export const IDK_OPTION_VALUE = "I don't know";

export const customOptions = (type: string): any => ({
  I_DONT_KNOW: {
    [`${type}_id`]: CustomDropdownValues.negOne as number,
    [`${type}_name`]: IDK_OPTION_VALUE,
    models: [],
  },
  OTHER: {
    [`${type}_id`]: 'other',
    [`${type}_name`]: 'Other',
    models: [],
  },
});

/* Priority Survey Que */
export const PRIORITY_SURVEY_QUE = [];

/**
 * SURVEY STATUSES
 */
export const SURVEY_STATUSES = {
  completed: 'completed',
  started: 'started',
  not_started: 'not_started',
};

/**
 * Session Storage Keys
 */
export const inActiveSurveySession = 'surveyWelcomeBackNotification';
export const inRecommendationSession = 'recommendationLoadingPage';
